<div class="modal-header">
  <div class="modal-title">Switch to AdvanceCM now for free!</div>
  <button (click)="close()" class="close">
    <span class="far fa-times"></span>
  </button>
</div>
<div class="modal-body p-0 position-relative" style="overflow: visible">
  <div #loading>
    <app-loading-section></app-loading-section>
  </div>

  <div #demo style="display: none"></div>
</div>

<div class="modal-footer m-0 p-2 d-flex align-items-center">
  <div style="font-weight: 500">We have already set up your account. Start using AdvanceCM.</div>
  <button type="button" class="btn btn-cst-info" (click)="goToACM()">Go to AdvanceCM</button>
</div>
